import { SVGProps } from 'react';

type IconProps = SVGProps<SVGSVGElement>;

export function HomeIcon(props: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M11.47 3.841a.75.75 0 0 1 1.06 0l8.69 8.69a.75.75 0 1 0 1.06-1.061l-8.689-8.69a2.25 2.25 0 0 0-3.182 0l-8.69 8.69a.75.75 0 1 0 1.061 1.06l8.69-8.689Z" />
      <path d="m12 5.432 8.159 8.159c.03.03.06.058.091.086v6.198c0 1.035-.84 1.875-1.875 1.875H15a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 0-.75-.75h-3a.75.75 0 0 0-.75.75V21a.75.75 0 0 1-.75.75H5.625a1.875 1.875 0 0 1-1.875-1.875v-6.198a2.29 2.29 0 0 0 .091-.086L12 5.432Z" />
    </svg>
  );
}

export function DumbbellIcon(props: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path fillRule="evenodd" d="M3.75 6a.75.75 0 0 1 .75.75v3.75h1.5V6.75a.75.75 0 0 1 1.5 0v3.75h.75a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-.75.75h-.75v3.75a.75.75 0 0 1-1.5 0v-3.75H4.5v3.75a.75.75 0 0 1-1.5 0v-3.75H2.25a.75.75 0 0 1-.75-.75v-1.5a.75.75 0 0 1 .75-.75H3V6.75A.75.75 0 0 1 3.75 6ZM20.25 6a.75.75 0 0 1 .75.75v3.75h.75a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-.75.75H21v3.75a.75.75 0 0 1-1.5 0v-3.75h-1.5v3.75a.75.75 0 0 1-1.5 0v-3.75h-.75a.75.75 0 0 1-.75-.75v-1.5a.75.75 0 0 1 .75-.75h.75V6.75a.75.75 0 0 1 1.5 0v3.75h1.5V6.75a.75.75 0 0 1 .75-.75ZM9.75 11.25a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5Z" clipRule="evenodd" />
    </svg>
  );
}

export function ListIcon(props: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path fillRule="evenodd" d="M2.625 6.75a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Zm4.875 0A.75.75 0 0 1 8.25 6h12a.75.75 0 0 1 0 1.5h-12a.75.75 0 0 1-.75-.75ZM2.625 12a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0ZM7.5 12a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5h-12A.75.75 0 0 1 7.5 12Zm-4.875 5.25a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Zm4.875 0a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5h-12a.75.75 0 0 1-.75-.75Z" clipRule="evenodd" />
    </svg>
  );
}

export function ChartIcon(props: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M18.375 2.25c-1.035 0-1.875.84-1.875 1.875v15.75c0 1.035.84 1.875 1.875 1.875h.75c1.035 0 1.875-.84 1.875-1.875V4.125c0-1.036-.84-1.875-1.875-1.875h-.75ZM9.75 8.625c0-1.036.84-1.875 1.875-1.875h.75c1.036 0 1.875.84 1.875 1.875v11.25c0 1.035-.84 1.875-1.875 1.875h-.75a1.875 1.875 0 0 1-1.875-1.875V8.625ZM3 13.125c0-1.036.84-1.875 1.875-1.875h.75c1.036 0 1.875.84 1.875 1.875v6.75c0 1.035-.84 1.875-1.875 1.875h-.75A1.875 1.875 0 0 1 3 19.875v-6.75Z" />
    </svg>
  );
}

export function RulerIcon(props: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path fillRule="evenodd" d="M20.03 3.97a.75.75 0 0 1 0 1.06l-2.5 2.5a.75.75 0 0 1-1.06-1.06l2.5-2.5a.75.75 0 0 1 1.06 0ZM15.53 8.47a.75.75 0 0 1 0 1.06l-2.5 2.5a.75.75 0 1 1-1.06-1.06l2.5-2.5a.75.75 0 0 1 1.06 0ZM11.03 12.97a.75.75 0 0 1 0 1.06l-2.5 2.5a.75.75 0 1 1-1.06-1.06l2.5-2.5a.75.75 0 0 1 1.06 0ZM6.53 17.47a.75.75 0 0 1 0 1.06l-2.5 2.5a.75.75 0 0 1-1.06-1.06l2.5-2.5a.75.75 0 0 1 1.06 0ZM21.53 11.03a.75.75 0 0 1 0 1.06l-9.44 9.44a2.25 2.25 0 0 1-1.591.659H6.75A.75.75 0 0 1 6 21.44v-3.75a2.25 2.25 0 0 1 .659-1.591l9.44-9.44a.75.75 0 0 1 1.06 0l4.371 4.371Z" clipRule="evenodd" />
    </svg>
  );
}

export function UserIcon(props: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path fillRule="evenodd" d="M7.5 6a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM3.751 20.105a8.25 8.25 0 0 1 16.498 0 .75.75 0 0 1-.437.695A18.683 18.683 0 0 1 12 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 0 1-.437-.695Z" clipRule="evenodd" />
    </svg>
  );
}

export function PlusIcon(props: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path fillRule="evenodd" d="M12 3.75a.75.75 0 0 1 .75.75v6.75h6.75a.75.75 0 0 1 0 1.5h-6.75v6.75a.75.75 0 0 1-1.5 0v-6.75H4.5a.75.75 0 0 1 0-1.5h6.75V4.5a.75.75 0 0 1 .75-.75Z" clipRule="evenodd" />
    </svg>
  );
}

export function ChevronLeftIcon(props: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path fillRule="evenodd" d="M7.72 12.53a.75.75 0 0 1 0-1.06l7.5-7.5a.75.75 0 1 1 1.06 1.06L9.31 12l6.97 6.97a.75.75 0 1 1-1.06 1.06l-7.5-7.5Z" clipRule="evenodd" />
    </svg>
  );
}

export function ChevronRightIcon(props: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path fillRule="evenodd" d="M16.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z" clipRule="evenodd" />
    </svg>
  );
}

export function XMarkIcon(props: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path fillRule="evenodd" d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z" clipRule="evenodd" />
    </svg>
  );
}

export function CheckIcon(props: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path fillRule="evenodd" d="M19.916 4.626a.75.75 0 0 1 .208 1.04l-9 13.5a.75.75 0 0 1-1.154.114l-6-6a.75.75 0 0 1 1.06-1.06l5.353 5.353 8.493-12.74a.75.75 0 0 1 1.04-.207Z" clipRule="evenodd" />
    </svg>
  );
}

export function TrashIcon(props: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path fillRule="evenodd" d="M16.5 4.478v.227a48.816 48.816 0 0 1 3.878.512.75.75 0 1 1-.256 1.478l-.209-.035-1.005 13.07a3 3 0 0 1-2.991 2.77H8.084a3 3 0 0 1-2.991-2.77L4.087 6.66l-.209.035a.75.75 0 0 1-.256-1.478A48.567 48.567 0 0 1 7.5 4.705v-.227c0-1.564 1.213-2.9 2.816-2.951a52.662 52.662 0 0 1 3.369 0c1.603.051 2.815 1.387 2.815 2.951Zm-6.136-1.452a51.196 51.196 0 0 1 3.273 0C14.39 3.05 15 3.684 15 4.478v.113a49.488 49.488 0 0 0-6 0v-.113c0-.794.609-1.428 1.364-1.452Zm-.355 5.945a.75.75 0 1 0-1.5.058l.347 9a.75.75 0 1 0 1.499-.058l-.346-9Zm5.48.058a.75.75 0 1 0-1.498-.058l-.347 9a.75.75 0 0 0 1.5.058l.345-9Z" clipRule="evenodd" />
    </svg>
  );
}

export function LogoutIcon(props: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path fillRule="evenodd" d="M7.5 3.75A1.5 1.5 0 0 0 6 5.25v13.5a1.5 1.5 0 0 0 1.5 1.5h6a1.5 1.5 0 0 0 1.5-1.5V15a.75.75 0 0 1 1.5 0v3.75a3 3 0 0 1-3 3h-6a3 3 0 0 1-3-3V5.25a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3V9A.75.75 0 0 1 15 9V5.25a1.5 1.5 0 0 0-1.5-1.5h-6Zm10.72 4.72a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1 0 1.06l-3 3a.75.75 0 1 1-1.06-1.06l1.72-1.72H9a.75.75 0 0 1 0-1.5h10.94l-1.72-1.72a.75.75 0 0 1 0-1.06Z" clipRule="evenodd" />
    </svg>
  );
}

export function CogIcon(props: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path fillRule="evenodd" d="M11.078 2.25c-.917 0-1.699.663-1.85 1.567L9.05 4.889c-.02.12-.115.26-.297.348a7.493 7.493 0 0 0-.986.57c-.166.115-.334.126-.45.083L6.3 5.508a1.875 1.875 0 0 0-2.282.819l-.922 1.597a1.875 1.875 0 0 0 .432 2.385l.84.692c.095.078.17.229.154.43a7.598 7.598 0 0 0 0 1.139c.015.2-.059.352-.153.43l-.841.692a1.875 1.875 0 0 0-.432 2.385l.922 1.597a1.875 1.875 0 0 0 2.282.818l1.019-.382c.115-.043.283-.031.45.082.312.214.641.405.985.57.182.088.277.228.297.35l.178 1.071c.151.904.933 1.567 1.85 1.567h1.844c.916 0 1.699-.663 1.85-1.567l.178-1.072c.02-.12.114-.26.297-.349.344-.165.673-.356.985-.57.167-.114.335-.125.45-.082l1.02.382a1.875 1.875 0 0 0 2.28-.819l.923-1.597a1.875 1.875 0 0 0-.432-2.385l-.84-.692c-.095-.078-.17-.229-.154-.43a7.614 7.614 0 0 0 0-1.139c-.016-.2.059-.352.153-.43l.84-.692c.708-.582.891-1.59.433-2.385l-.922-1.597a1.875 1.875 0 0 0-2.282-.818l-1.02.382c-.114.043-.282.031-.449-.083a7.49 7.49 0 0 0-.985-.57c-.183-.087-.277-.227-.297-.348l-.179-1.072a1.875 1.875 0 0 0-1.85-1.567h-1.843ZM12 15.75a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5Z" clipRule="evenodd" />
    </svg>
  );
}

export function ForkKnifeIcon(props: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M5.25 2.25a.75.75 0 0 1 .75.75v6.75h.75v-6.75a.75.75 0 0 1 1.5 0v6.75h.75v-6.75a.75.75 0 0 1 1.5 0V9c0 1.657-1.007 3.078-2.438 3.685l-.062.023v8.542a.75.75 0 0 1-1.5 0v-8.542l-.062-.023C5.007 12.078 4 10.657 4 9V3a.75.75 0 0 1 .75-.75h.5ZM18.75 3a.75.75 0 0 1 .75.75v17.5a.75.75 0 0 1-1.5 0v-6.25h-2.25a.75.75 0 0 1-.75-.75V7.5a4.5 4.5 0 0 1 3.75-4.436V3ZM17.25 6.192A3.002 3.002 0 0 0 15.75 8.75v4.5h1.5V6.192Z" />
    </svg>
  );
}

// Muscle Group Icons - Clean, simple designs

// Chest - stylized pecs
export function ChestIcon(props: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M4 8c0-1 .5-2 1.5-2.5S7.5 5 9 5c1 0 2 .2 3 .5 1-.3 2-.5 3-.5 1.5 0 3 0 4 .5S21 7 21 8c0 2-.5 4-1.5 5.5-.5.8-1.2 1.3-2 1.5-.3 1-.8 2-1.5 2.5-.5.4-1.2.5-2 .5h-4c-.8 0-1.5-.1-2-.5-.7-.5-1.2-1.5-1.5-2.5-.8-.2-1.5-.7-2-1.5C3.5 12 3 10 3 8h1z"/>
    </svg>
  );
}

// Back - V-taper shape
export function BackIcon(props: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M12 2c-1 0-2 .5-2.5 1L7 5.5C5.5 7 4.5 9 4 11c-.3 1-.5 2-.5 3 0 1.5.5 3 1.5 4l2 2.5c.5.5 1 1 1.5 1.5.5.3 1.2.5 2 .5h3c.8 0 1.5-.2 2-.5.5-.5 1-1 1.5-1.5l2-2.5c1-1 1.5-2.5 1.5-4 0-1-.2-2-.5-3-.5-2-1.5-4-3-5.5L14.5 3c-.5-.5-1.5-1-2.5-1zm0 4c.5 0 1 .2 1.5.5l2 2c1 1 1.5 2.5 1.5 4v3c0 .5-.2 1-.5 1.5l-1 1c-.3.3-.7.5-1 .5h-5c-.3 0-.7-.2-1-.5l-1-1c-.3-.5-.5-1-.5-1.5v-3c0-1.5.5-3 1.5-4l2-2c.5-.3 1-.5 1.5-.5z"/>
    </svg>
  );
}

// Shoulders - deltoid caps
export function ShouldersIcon(props: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
      <ellipse cx="5" cy="10" rx="3" ry="4"/>
      <ellipse cx="19" cy="10" rx="3" ry="4"/>
      <path d="M8 9c0-1 .8-2 2-2.5 1-.3 1.5-.5 2-.5s1 .2 2 .5c1.2.5 2 1.5 2 2.5v4c0 1-.5 2-1.5 2.5-.5.3-1.2.5-2.5.5s-2-.2-2.5-.5C8.5 15 8 14 8 13V9z"/>
    </svg>
  );
}

// Biceps - flexed arm
export function BicepsIcon(props: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M6 4c-.5 0-1 .3-1.5.8S4 5.8 4 6.5c0 1 .3 2 .8 3 .3.5.5 1 .7 1.5v9.5c0 .3.2.5.5.5h2c.3 0 .5-.2.5-.5V11c.2-.5.5-1 .8-1.5.5-1 .7-2 .7-3 0-.7-.2-1.2-.5-1.7S9 4 8.5 4H6z"/>
      <path d="M12 6c-1 0-1.8.5-2.3 1.3-.3.5-.5 1.2-.5 2 0 1.2.4 2.5 1 3.7.4.7.7 1.3 1 2v6.5c0 .3.2.5.5.5h1c.3 0 .5-.2.5-.5V15c.3-.7.6-1.3 1-2 .6-1.2 1-2.5 1-3.7 0-.8-.2-1.5-.5-2C14.2 6.5 13 6 12 6z"/>
      <ellipse cx="17" cy="8" rx="3" ry="4"/>
    </svg>
  );
}

// Triceps - back of arm
export function TricepsIcon(props: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M8 3c-.8 0-1.5.3-2 .8S5.2 4.8 5 5.5c-.2 1-.2 2 0 3 .2.8.5 1.5 1 2v10c0 .3.2.5.5.5h2c.3 0 .5-.2.5-.5v-10c.5-.5.8-1.2 1-2 .2-1 .2-2 0-3-.2-.7-.5-1.2-1-1.7S8.8 3 8 3z"/>
      <path d="M15 3c-.8 0-1.5.3-2 .8s-.8 1-1 1.7c-.2 1-.2 2 0 3 .2.8.5 1.5 1 2v10c0 .3.2.5.5.5h2c.3 0 .5-.2.5-.5v-10c.5-.5.8-1.2 1-2 .2-1 .2-2 0-3-.2-.7-.5-1.2-1-1.7S15.8 3 15 3z"/>
    </svg>
  );
}

// Quads - thigh muscles front
export function QuadsIcon(props: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M6 3c-.8 0-1.5.5-2 1.2-.5.8-.8 1.8-1 3-.2 2 0 4.5.5 7 .3 1.5.7 3 1 4v3.3c0 .3.2.5.5.5h2c.3 0 .5-.2.5-.5V18c.2-.8.3-1.8.5-3 .3-2.5.3-5 0-7-.2-1.2-.5-2.2-1-3S6.8 3 6 3z"/>
      <path d="M18 3c-.8 0-1.5.5-2 1.2-.5.8-.8 1.8-1 3-.3 2-.3 4.5 0 7 .2 1.2.3 2.2.5 3v3.3c0 .3.2.5.5.5h2c.3 0 .5-.2.5-.5V18c.3-1 .7-2.5 1-4 .5-2.5.7-5 .5-7-.2-1.2-.5-2.2-1-3S18.8 3 18 3z"/>
    </svg>
  );
}

// Hamstrings - back of thigh
export function HamstringsIcon(props: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M7 2c-1 0-1.8.5-2.3 1.2-.5.8-.7 1.8-.7 3 0 2 .3 4.5 1 7 .3 1.2.7 2.3 1 3v4.3c0 .3.2.5.5.5h1c.3 0 .5-.2.5-.5v-4c.3-.5.5-1.2.7-2 .5-2 .8-4.5.8-7 0-1-.2-2-.5-2.7C8.5 3.5 8 2.8 7.5 2.5 7.3 2.2 7 2 7 2z"/>
      <path d="M12 4c-.5 0-1 .3-1.3.8-.3.5-.5 1.2-.5 2 0 1.5.3 3.5.8 5.5.2 1 .5 2 .7 2.7v5.5c0 .3.2.5.5.5h.6c.3 0 .5-.2.5-.5V15c.2-.7.5-1.7.7-2.7.5-2 .8-4 .8-5.5 0-.8-.2-1.5-.5-2-.3-.5-.8-.8-1.3-.8z"/>
      <path d="M17 2c0 0-.3.2-.5.5-.5.3-1 1-1.5 1.8-.3.7-.5 1.7-.5 2.7 0 2.5.3 5 .8 7 .2.8.4 1.5.7 2v4c0 .3.2.5.5.5h1c.3 0 .5-.2.5-.5v-4.3c.3-.7.7-1.8 1-3 .7-2.5 1-5 1-7 0-1.2-.2-2.2-.7-3C18.8 2.5 18 2 17 2z"/>
    </svg>
  );
}

// Glutes - rounded shapes
export function GlutesIcon(props: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
      <ellipse cx="7" cy="12" rx="5" ry="6"/>
      <ellipse cx="17" cy="12" rx="5" ry="6"/>
    </svg>
  );
}

// Calves - lower leg
export function CalvesIcon(props: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M7 2c-.5 0-1 .3-1.3.8-.3.5-.5 1.2-.7 2-.2 1-.3 2.2-.3 3.5 0 2 .2 4.2.7 6.2.2 1 .5 2 .8 2.8v3.2c0 .3.2.5.5.5h1.6c.3 0 .5-.2.5-.5v-3c.2-.7.3-1.5.5-2.3.3-2 .5-4 .5-6 0-1.2-.2-2.3-.5-3.2-.3-1-.7-1.7-1.2-2.2C7.8 2.3 7.3 2 7 2z"/>
      <path d="M17 2c-.3 0-.8.3-1.1.8-.5.5-.9 1.2-1.2 2.2-.3.9-.5 2-.5 3.2 0 2 .2 4 .5 6 .2.8.3 1.6.5 2.3v3c0 .3.2.5.5.5h1.6c.3 0 .5-.2.5-.5v-3.2c.3-.8.6-1.8.8-2.8.5-2 .7-4.2.7-6.2 0-1.3-.1-2.5-.3-3.5-.2-.8-.4-1.5-.7-2-.3-.5-.8-.8-1.3-.8z"/>
    </svg>
  );
}

// Abs - six pack
export function AbsIcon(props: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
      <rect x="7" y="3" width="4" height="5" rx="1"/>
      <rect x="13" y="3" width="4" height="5" rx="1"/>
      <rect x="7" y="9.5" width="4" height="5" rx="1"/>
      <rect x="13" y="9.5" width="4" height="5" rx="1"/>
      <rect x="7" y="16" width="4" height="5" rx="1"/>
      <rect x="13" y="16" width="4" height="5" rx="1"/>
    </svg>
  );
}

// Forearms
export function ForearmsIcon(props: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M5 2c-.5 0-1 .3-1.3.8-.3.5-.5 1.2-.7 2-.2 1.2-.2 2.5 0 4 .2 1.2.5 2.5 1 3.5v8.2c0 .3.2.5.5.5h2c.3 0 .5-.2.5-.5v-8c.3-.8.5-1.8.7-3 .3-1.5.3-3 .1-4.2-.2-.8-.4-1.5-.7-2C6.8 2.5 6.3 2 5.8 2H5z"/>
      <path d="M11 4c-.4 0-.8.2-1.1.6-.3.4-.5 1-.6 1.6-.2 1-.2 2.2 0 3.5.1.8.3 1.7.6 2.5v8.3c0 .3.2.5.5.5h1.2c.3 0 .5-.2.5-.5v-8c.2-.7.4-1.5.5-2.3.3-1.3.3-2.5.1-3.5-.1-.7-.3-1.2-.5-1.6-.3-.4-.7-.6-1.2-.6z"/>
      <path d="M17 2c-.5 0-1 .3-1.3.8-.3.5-.5 1.2-.7 2-.2 1.2-.2 2.7.1 4.2.2 1.2.4 2.2.7 3v8c0 .3.2.5.5.5h2c.3 0 .5-.2.5-.5v-8.2c.5-1 .8-2.3 1-3.5.2-1.5.2-2.8 0-4-.2-.8-.4-1.5-.7-2-.3-.5-.8-.8-1.3-.8h-.8z"/>
    </svg>
  );
}

// Map muscle groups to icons
export const MUSCLE_ICONS: Record<string, React.FC<IconProps>> = {
  chest: ChestIcon,
  back: BackIcon,
  shoulders: ShouldersIcon,
  biceps: BicepsIcon,
  triceps: TricepsIcon,
  quads: QuadsIcon,
  hamstrings: HamstringsIcon,
  glutes: GlutesIcon,
  calves: CalvesIcon,
  abs: AbsIcon,
  forearms: ForearmsIcon,
};
